export { default } from "./SlicerImage"
